import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { teamQueryKeys } from '../teamQueryKeys';
import { FIVE_MINUTES } from '@constants/date';
import {
  FetchTeamMemberStatisticsAxiosErrorResponse,
  FetchTeamEmployeeStatisticsPayload,
  FetchTeamMemberStatisticsAxiosSuccessResponse,
} from 'TeamModule/types';
import { fetchTeamEmployeeStatistics } from 'TeamModule/services';

export const useTeamMemberStatisticsQuery = (params: FetchTeamEmployeeStatisticsPayload) => {
  const { team_id } = params;

  const query = useAppQuery<
    FetchTeamMemberStatisticsAxiosSuccessResponse,
    FetchTeamMemberStatisticsAxiosErrorResponse
  >({
    queryKey: teamQueryKeys.detail({
      teamId: team_id,
      identifier: `useTeamMemberStatisticsQuery`,
    }),
    queryFn: ({ token, buildConfig }) =>
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      fetchTeamEmployeeStatistics({
        params,
        token,
        config: buildConfig(),
      }) as Promise<FetchTeamMemberStatisticsAxiosSuccessResponse>,
    staleTime: FIVE_MINUTES,
  });

  return {
    teamMemberStatisticsData: query.data?.data,
    teamMemberStatisticsError: query.error?.data
      ? (query.error?.data?.errors?.[0] ?? 'Something went wrong')
      : undefined,
    isLoadingTeamMemberStatistics: query.isLoading,
  };
};
